import { QUESTIONS } from '../data/questions';
import { RECOMMENDED_ACTIONS } from '../data/recommendedActions';

/**
 * Returns the steps array for a given action by matching on question_id + title.
 */
export function getActionSteps(action) {
  if (!action.question_id) return [];
  const templates = RECOMMENDED_ACTIONS[action.question_id] || [];
  const match = templates.find((t) => t.title === action.title);
  return match?.steps || [];
}

/**
 * Returns the list of recommended actions that should exist for a client/dimension
 * given the current assessment scores (triggers on score < 3).
 */
export function deriveRecommendedActions(assessments, clientId, dimNum) {
  const qs = QUESTIONS[dimNum] || [];
  const result = [];

  for (const q of qs) {
    const assessment = assessments.find(
      (a) => a.client_id === clientId && a.dimension === dimNum && a.question_id === q.id
    );
    const score = assessment?.score ?? null;
    if (score !== null && score < 3) {
      const templates = RECOMMENDED_ACTIONS[q.id] || [];
      for (const t of templates) {
        result.push({
          client_id: clientId,
          dimension: dimNum,
          question_id: q.id,
          title: t.title,
          description: t.description,
          status: 'todo',
          is_custom: false,
        });
      }
    }
  }

  return result;
}

/**
 * Given existing actions and derived recommended actions, returns only the
 * recommended actions that are not already present (by title + question_id).
 * Never deletes existing actions.
 */
export function getMissingRecommendedActions(existingActions, derivedActions, clientId, dimNum) {
  const dimExisting = existingActions.filter(
    (a) => a.client_id === clientId && a.dimension === dimNum && !a.is_custom
  );

  return derivedActions.filter((derived) => {
    return !dimExisting.some(
      (e) => e.question_id === derived.question_id && e.title === derived.title
    );
  });
}
